const allinstallrescedulePopulate = { data: [], loading: true };
const resceduledata = {};

export const GetAllInstallRescedulePopulateRed = (state = allinstallrescedulePopulate, action) => {
  switch (action.type) {
    case "get_installrescedule":
      return {
        data: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

export const GetresceduledataReducer = (state = resceduledata, action) => {
  switch (action.type) {
    case "get_resceduledata":
      return {
        resceduledata: action.payload,
      };
    default:
      return state;
  }
};

const initialState = {
  rescheduleUnits: [],
};

const rescheduleUnitReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_RESCHEDULE_UNITS":
      return {
        ...state,
        rescheduleUnits: action.payload,
      };
    default:
      return state;
  }
};

export default rescheduleUnitReducer;
